const Index = () => import('./index.vue');

export default [
    {
        path: '/compare',
        component: Index
    }
]